export const options = [
	{
		label: "Unreal RP [UA]",
		value: "1",
		lang: "ua",
		currency: "₴",
		ratio: 1,
		min: 20,
		isBonus: true,
		donateMultiplayer: 1,
		bonuses: [
			{ percent: 5, amount: 1000 },
			{ percent: 10, amount: 3000 },
			{ percent: 15, amount: 6000 },
			{ percent: 20, amount: 10000 },
			{ percent: 25, amount: 15000 },
		],
	},
	// {
	//     label: "Unreal RP [GE]",
	//     value: "2",
	//     lang: "ge",
	//     currency: "₾",
	//     ratio: 15,
	//     min: 5,
	//     isBonus: true,
	//     donateMultiplayer: 2,
	//     bonuses: [
	//         { percent: 5, amount: 70 },
	//         { percent: 10, amount: 200 },
	//         { percent: 15, amount: 400 },
	//         { percent: 20, amount: 700 },
	//         { percent: 25, amount: 1000 },
	//     ]
	// }
	{
		label: "Unreal RP [DE]",
		value: "3",
		lang: "de",
		currency: "€",
		ratio: 50,
		min: 1,
		isBonus: true,
		donateMultiplayer: 1,
		bonuses: [
			{ percent: 5, amount: 20 },
			{ percent: 10, amount: 60 },
			{ percent: 15, amount: 120 },
			{ percent: 20, amount: 200 },
			{ percent: 25, amount: 300 },
		],
	},
]
